import { render, staticRenderFns } from "./OpsWall.vue?vue&type=template&id=094e8653&scoped=true"
import script from "./OpsWall.vue?vue&type=script&lang=js"
export * from "./OpsWall.vue?vue&type=script&lang=js"
import style0 from "./OpsWall.vue?vue&type=style&index=0&id=094e8653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e8653",
  null
  
)

export default component.exports